<script>
import {
  required
} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader.vue";

export default {
  name: 'CreateStock',
  props:[
    "list",
    "data"
  ],
   components: { Loader },
  data() {
        return {
            groups:[
                { name:"Mikrotik", code:"an-1"},
                { name:"Ubiquiti", code:"an-2"},
                { name:"Mimosa", code:"an-3"},
                { name:"Kablo", code:"ka"},
                { name:"Modem", code:"mo"},
                { name:"Sarf Malzeme", code:"sm"},
            ],
            groupList:[],
            userList:[],
            lines:[],
            form:{
                model:'',
                group:'',
                user_id:'',
                ip:''
            },
            submitted: false,
            seri_no:'',
            adet:1,
            loading:false,
        };
    },
    watch:{
        list(props){
            this.form = props
        },
        data(){
            this.lines = []
            this.form= {
                model:'',
                group:'',
                user_id:''
            }
            this.seri_no= ''
            this.adet=1
        }
    },
    created(){
        this.$http.post('/users?output=one&fields=id,name&depo=1')
        .then(resp => { this.userList = resp.data })
    },
    validations: {
        form: {
            group: { required },
            model: { required },
            user_id: { required },
        },
    },
    methods: {
        close() {
            this.$parent.$bvModal.hide('modal-scoped')
        },
        newLine() {
            this.loading = false
            const postLine = { seri_no:this.seri_no, amount:this.adet, ip: this.form.ip }
            const { model, user_id } = this.form

            this.$http.post('/stock/store', { ...postLine, stock_group_id:model.id, user_id })
                .then(({ data }) => {
                    if (data.error) {
                        this.playErrorSound()
                        return
                    }

                    this.lines.push({...postLine, id:data.content.id})
                    this.$emit('loadItems');
                })

            this.seri_no = ''
            this.form.ip = ''
        },
        getGroupList({target}){
            this.$http.post('/stock/product?id=' + target.value)
                .then(response => this.groupList = response.data)
        },
        playErrorSound() {
            const audio = new Audio(require('@/assets/images/error.mp3'));
            audio.play();
        },
        formGroup() {
            return this.form.group.replace(/-\d+.*$/, "") == 'an' || this.form.group == 'mo'
        },
        lineRemove(props, idx) {
            this.$http.delete('/stock/' + props.id)
                .then(() => {
                    this.lines.splice(idx, 1)
                    this.$emit('loadItems');
                })
        }
    },
};
</script>

<template>
  <b-modal
        size="lg"
        id="modal-scoped"
        title="Depo Stok Ekleme"
        no-close-on-backdrop
        hide-footer>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="groups">Ürün Grubu</label>
            <div class="col-sm-8">
                <select
                    class="form-control form-select"
                    :class="{'is-invalid': submitted && $v.form.group.$error}"
                    @change="getGroupList($event)"
                    v-model="form.group">
                    <option value="">Seçiniz</option>
                    <option :value="group.code" v-for="(group,i) in groups" :key="i">{{ group.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.group.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="models">Tanım</label>
            <div class="col-sm-8">
                <select
                    class="form-control form-select"
                    :class="{'is-invalid': submitted && $v.form.model.$error}"
                    v-model="form.model">
                    <option value="">Seçiniz</option>
                    <option :value="model" v-for="(model,i) in groupList" :key="i">{{ model.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.model.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row">
            <label class="col-sm-4 col-form-label" for="depo">Depo</label>
            <div class="col-sm-8">
                <select
                    class="form-control form-select"
                    :class="{'is-invalid': submitted && $v.form.user_id.$error}"
                    v-model="form.user_id">
                    <option value="">Seçiniz</option>
                    <option :value="user.id" v-for="(user,i) in userList" :key="i">{{ user.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.user_id.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <hr>
        <Loader :loading="true" :load="loading" v-if="form.group && form.model">
            <div class="row mb-1" >
                <div class="col-md-12" style="max-height:480px;overflow:auto">
                    <div class="d-flex mb-1">
                        <div class="col-md-6 me-2">
                             <input
                                v-if="formGroup()"
                                type="text"
                                class="form-control"
                                placeholder="Seri No"
                                v-model="seri_no"
                                @keyup.enter="newLine()"
                            />
                        </div>
                        <div class="col-md-4 me-2 ">
                            <div class="input-group mb-3">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Adet"
                                    v-model="adet"
                                />
                                <span class="input-group-text">{{ form.model.unit }}</span>
                            </div>
                        </div>
                        <div class="col">
                            <button
                            style="width:100%"
                            type="button"
                            class="btn btn-success"
                            @click="newLine()">Ekle</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2 mb-1" v-if="lines.length>0" >
                <div class="col-md-12" style="max-height:480px;overflow:auto">
                Son Eklenen Data:
                    <div class="d-flex mb-1" v-for="(line,i) in lines" :key="i">
                        <div class="col-md-1 rounded-2 me-2 bg-light py-1 px-3">
                            {{ i+1 }}
                        </div>
                        <div class="col-md-7 rounded-2 me-2 bg-light py-1 px-3">
                            {{ line.seri_no }}
                        </div>
                         <div class="col-md-2 rounded-2 me-2 bg-light py-1 px-3">
                            {{ line.amount }}
                        </div>
                        <div class="col d-grid gap-2">
                            <button type="button" @click="lineRemove(line, i)" class="btn btn-sm btn-block btn-danger">Sil</button>
                        </div>
                    </div>
                </div>
            </div>
        </Loader>
</b-modal>
</template>